import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const NewSubDepManagmentAssignmentCover = ({ notification }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={
        rtl
          ? `لقد تم تعيينك مديراً لقسم فرعى`
          : 'You have been assigned as manager for a new sundeparment'
      }
    />
  )
}

export default NewSubDepManagmentAssignmentCover
